import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import { CheckItem } from './ui/CheckItem';
import { insideScreenshots, insideBenefits } from '../data/sections';
import { INSIDE_IMAGES } from '../data/images';
export function InsideCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 'left' | 'right') => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({
      left: dir === 'left' ? -320 : 320,
      behavior: 'smooth'
    });
  };
  return <section className="bg-mp-black py-16 md:py-24" data-id="element-172" data-mp="2klm5x31981f6">
      <Container data-id="element-173" data-mp="2kmx7cw788x34">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end" data-id="element-174" data-mp="2kmfem9jrx0zy">
          <div className="max-w-[650px]" data-id="element-175" data-mp="2ylojid2j48om">
            <SectionTag tone="white" data-id="element-176" data-mp="2tmu3tjzuz08q">Sin letra pequeña</SectionTag>
            <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-177" data-mp="2tk7novywjcew">
              No tienes que imaginarte lo que recibes.
            </h2>
            <p className="mt-2 text-base text-mp-gray" data-id="element-178" data-mp="2rsn8jp4t75iw">Así es Maestro en Pista por dentro.</p>
          </div>

          <div className="hidden gap-2 md:flex" data-id="element-179" data-mp="2wpwzxabrdr9d">
            <button type="button" onClick={() => scroll('left')} aria-label="Ver capturas anteriores" className="flex h-11 w-11 items-center justify-center rounded-full border border-mp-border text-mp-white transition-colors duration-150 hover:border-mp-lime hover:text-mp-lime" data-id="element-180" data-mp="30tbgc23m09nc">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-181" data-mp="3fjsqc9ub87vu" />
            </button>
            <button type="button" onClick={() => scroll('right')} aria-label="Ver más capturas" className="flex h-11 w-11 items-center justify-center rounded-full border border-mp-border text-mp-white transition-colors duration-150 hover:border-mp-lime hover:text-mp-lime" data-id="element-182" data-mp="3kfhihs402mi4">
              <ChevronRightIcon className="h-5 w-5" data-id="element-183" data-mp="1tcvcmy16i3vx" />
            </button>
          </div>
        </div>

        <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2" data-id="element-184" data-mp="2350ydq0u7p2o">
          {insideBenefits.map(b => <CheckItem key={b} inline data-id="element-185" data-mp="1yeaw4lnpk2c7">
              {b}
            </CheckItem>)}
        </ul>

        <div ref={trackRef} className="scrollbar-hide mt-8 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2" data-id="element-186" data-mp="2d2yo6hychtxe">
          {insideScreenshots.map(label => <div key={label} className="w-[78%] flex-shrink-0 snap-start sm:w-[55%] md:w-[calc(33.333%-14px)]" data-id="element-187" data-mp="283ub3g8avc1s">
              <PlaceholderMockup label={label} aspect="aspect-[2/3]" src={INSIDE_IMAGES[label]} alt={`Vista interior de Maestro en Pista — ${label}`} width={500} height={750} data-id="element-188" data-mp="2m1j112h859dp" />
            </div>)}
        </div>
      </Container>
    </section>;
}